import React from 'react';
import PropTypes from 'prop-types';

import ItemFactBox from "./ItemFactBox";
import ItemImageBox from "./ItemImageBox";
import ItemCartBox from "./ItemCartBox";
import {getClassList} from "../../../Utility/siteConfig";
import {camelizeKeysDeep} from "../../../ReduxStore/Helpers/transformObject";
import CatchErrors from "../../../Utility/CatchErrors";

export default function StandardItemDisplay({
  className,
  cartItem,
  shoppingCart,
  application,
  product,
  allProductSpecs=[],
}) {
  // FIXME: 2025-04 not camelized until we get here.
  product = camelizeKeysDeep(product);

  className = getClassList({
    key: 'StandardItemDisplay',
    append: className,
    fallback: "grid lg:grid-cols-3 mb-4 gap-2" // three equal columns
  });

  return <div className={className}>
    <CatchErrors><ItemImageBox product={product} /></CatchErrors>

    <CatchErrors><ItemFactBox
      product={product}
      application={application}
      allProductSpecs={allProductSpecs}
    /></CatchErrors>

    <CatchErrors><ItemCartBox
      product={product}
      application={application}
      cartItem={cartItem}
      shoppingCart={shoppingCart}
    /></CatchErrors>
  </div>;

}

StandardItemDisplay.propTypes = {
  product: PropTypes.object.isRequired,
  application: PropTypes.object, // optional, for universal
  cartItem: PropTypes.object
}
